import React, { Component } from 'react';
import { translate } from 'react-i18next';
import styled, { css, keyframes } from 'styled-components';

import RightChevron from './RightChevron';
import Spinner from './Spinner';

// a short shake so the operator sees (and on phones feels) that the tap registered
const shake = keyframes`
  0% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-3px); }
  80% { transform: translateX(3px); }
  100% { transform: translateX(0); }
`;
const FEEDBACK_MS = 350;

const Button = styled.button`
  color: ${props => props.theme.onSuccess}
  fill: ${props => props.theme.onSuccess}
  width: 140px;
  height: 50px;
  font-size: 14px;
  background: ${props => props.theme.success};
  border: none;
  text-align: center;
  white-space: nowrap;
  :disabled {
    background: ${props => props.theme.gray};
  }
  ${props =>
    props.shaking &&
    css`
      animation: ${shake} ${FEEDBACK_MS}ms ease-in-out;
    `}
`;

const Text = styled.span`
  text-align: right;
`;

const Chevron = styled.span`
  margin-left: 13px;
  margin-right: -23px;
`;

/**
 * Send button. `chevron={false}` hides the arrow; `feedback` shakes the button for a moment after a click and
 * vibrates the phone when the browser allows it, so the operator knows the tap registered even though the page
 * does not change.
 */
class SendButton extends Component {
  state = { shaking: false };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  handleClick = event => {
    const { feedback, onClick } = this.props;
    if (feedback) {
      if (typeof navigator !== 'undefined' && navigator.vibrate) {
        try {
          navigator.vibrate(40);
        } catch (e) {
          // vibration is best effort
        }
      }
      clearTimeout(this.timer);
      this.setState({ shaking: false }, () => {
        this.setState({ shaking: true });
        this.timer = setTimeout(
          () => this.setState({ shaking: false }),
          FEEDBACK_MS
        );
      });
    }
    if (onClick) onClick(event);
  };

  render() {
    const {
      t,
      text,
      loading,
      disabled,
      chevron = true,
      // taken out of `others` so it does not reach the DOM element; handleClick reads it from props
      // eslint-disable-next-line no-unused-vars
      feedback,
      onClick,
      ...others
    } = this.props;
    return (
      <Button
        disabled={loading || disabled}
        shaking={this.state.shaking}
        onClick={this.handleClick}
        {...others}
      >
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Text>{text || t('button.send')}</Text>
            {chevron && (
              <Chevron>
                <RightChevron />
              </Chevron>
            )}
          </>
        )}
      </Button>
    );
  }
}

export default translate()(SendButton);
